import { render, staticRenderFns } from "./PromotionsEffectRenderer.vue?vue&type=template&id=02e63f45&scoped=true&"
import script from "./PromotionsEffectRenderer.vue?vue&type=script&lang=js&"
export * from "./PromotionsEffectRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsEffectRenderer.vue?vue&type=style&index=0&id=02e63f45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e63f45",
  null
  
)

export default component.exports